const cardImage = document.querySelectorAll('.grid__item');

function removeNumbersFromEnd(str) {
  const regex = /(\d+)$/;
  const match = str.match(regex);
  if (match) {
    return Number(match[1]);
  } else {
    return null;
  }
}

cardImage.forEach(img => {
    img.addEventListener("mouseover", event => {
        let productId = event.target.getAttribute("id");
        const removedNumber = removeNumbersFromEnd(productId);
        document.getElementById(`quick-view-button-${removedNumber}`).style.display = 'block';
        const btn = document.getElementById(`quick-view-button-${removedNumber}`);
        btn.addEventListener("mouseover", event=>{
          btn.style.display = 'block';
        })
    });

    img.addEventListener("mouseout", event => {
        let productId = event.target.getAttribute("id");
        const removedNumber = removeNumbersFromEnd(productId);
        document.getElementById(`quick-view-button-${removedNumber}`).style.display = 'none';
    });
});

//list and grid view functionality
const grid = document.getElementById('grid-view');
const list = document.getElementById('list-view');
grid.style.opacity=0.5;
grid.addEventListener("click",event=>{
  document.getElementById(`product-grid`).style.display = 'flex';
  list.style.opacity=1;
  grid.style.opacity=0.5;
  //   cardRatio.forEach(card=>{
  //   card.style.flexDirection="column";
  // });
  // quickAdd.forEach(card=>{
  //   card.style.left="25%";
  // });
  // cardInfo.forEach(card=>{
  //   card.style.width="max-content";
  // });
  // gridItem.forEach(card=>{
  //   card.style.maxWidth="50%";
  //   card.style.minWidth="50%";
  //   card.style.width="50%";
  // });

});


const cardInfo = document.querySelectorAll('.card__information');
const gridItem = document.querySelectorAll('.grid__item');
const cardContent = document.querySelectorAll('.card__content');
const cardRatio = document.querySelectorAll('.card:not(.ratio)');
const quickAdd = document.querySelectorAll('.quick-add');
list.addEventListener("click",event=>{
  document.getElementById(`product-grid`).style.display = 'grid';
  list.style.opacity=0.5;
  grid.style.opacity=1;
  // cardRatio.forEach(card=>{
  //   card.style.flexDirection="row";
  // });
  // quickAdd.forEach(card=>{
  //   card.style.left="25%";
  // });
  // cardInfo.forEach(card=>{
  //   card.style.width="max-content";
  // });
  // gridItem.forEach(card=>{
  //   card.style.maxWidth="50%";
  //   card.style.minWidth="50%";
  //   card.style.width="50%";
  // });
});


